import type { FaireProductEntity } from "../../entity_types/product";

export const p_7srdr3shgj: FaireProductEntity = {
  token: "p_7srdr3shgj",
  type: "product",
  name: "Clearwater Full Lather Lye Soap \u2013 Salt Air Breeze, Clean Coastal Scent, Handmade Bar for Hardworking Hands & Body by Gulf Kind",
  brandName: "Gulf Kind",
  imageUrl:
    "https://cdn.faire.com/fastly/3a6718f237460535add24947b28e36e2c22d0f98b92e93332da6aaf5a2619746.png",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/581eb0f3dfb01d0bbd1470dc17afadbb72ad3f7385bc82e088511408ab6fc841.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
